// @flow
import moment from 'moment'
import { MODIFICATION_DEADLINE, QUOTA_USAGE_BY_MEMBER_DAILY } from '../constants/rules';
import type { PermitType, ReservationType } from '../types';
import {
    PERMIT_PRELIMINARY,
    PERMIT_IN_PROGRESS,
    PERMIT_COMPLETE,
    PERMIT_ISSUED,
    LOTTERY_IN_PROGRESS,
    LOTTERY_AWARDED,
    LOTTERY_AWARDED_IN_PROGRESS,
    LOTTERY_WON,
} from '../../src/constants';
import { issuanceReadable, issuanceStatuses, readRuleValue, hasRule } from '../../src/utils/utils';

// Lottery Issuance (aka Lottery Application)
export const isLotteryIssuance = (issuance: ReservationType) =>
    !!issuance.lottery_id && !issuance.lottery_issuance_id;

// Issuance created from accepting a lottery issuance
export const isIssuanceFromAwardedLottery = (issuance: ReservationType) =>
    !!issuance.lottery_id && !!issuance.lottery_issuance_id;

export function isPermitComplete(reservation: ReservationType) {
    return reservation?.status === issuanceStatuses.get(PERMIT_COMPLETE);
}

export function isIssuedPermit(reservation: ReservationType) {
    return (
      reservation.status === issuanceStatuses.get(PERMIT_ISSUED) ||
      reservation.status === issuanceStatuses.get(PERMIT_COMPLETE) ||
      reservation.status === issuanceStatuses.get(LOTTERY_AWARDED)
    );
}

export function getIssuanceReadableStatus(reservation: ReservationType) {
    return issuanceReadable.get(issuanceStatuses.get(reservation?.status))
}

export function isLotteryIssuanceConvertedFromIssuance(reservation: ReservationType) {
  return (
    reservation.status === issuanceStatuses.get(LOTTERY_AWARDED) ||
    reservation.status === issuanceStatuses.get(LOTTERY_AWARDED_IN_PROGRESS)
  )
}

export function isLotteryApplicationSubmitted(reservation: ReservationType) {
    return reservation.status > issuanceStatuses.get(LOTTERY_IN_PROGRESS);
}

export const isQuotaModifyAllowed = (reservation: ReservationType, permit: PermitType) => {
    const isAwardedLotteryApplication = reservation.status === issuanceStatuses.get(LOTTERY_WON)
    const isAcceptedAwardedReservationInProgress = reservation.lottery_awarded && reservation.status === issuanceStatuses.get(PERMIT_IN_PROGRESS)

    // can't modify quota of awarded lottery applications
    if (isAwardedLotteryApplication || isAcceptedAwardedReservationInProgress) {
        return false;
    }

    const hasQuotaByMember = hasRule(QUOTA_USAGE_BY_MEMBER_DAILY, permit.rules, reservation.division_id)
    const isPreliminaryOrInProgressReservation = [PERMIT_PRELIMINARY, PERMIT_IN_PROGRESS]
        .map((st) => issuanceStatuses.get(st))
        .includes(reservation.status)
    if(hasQuotaByMember && isPreliminaryOrInProgressReservation) {
        return true
    }

    let changesAllowed = hasQuotaByMember;

    const modificationDeadline = readRuleValue(MODIFICATION_DEADLINE, permit.rules);
    if (modificationDeadline !== '') {
        const entryDate = moment.utc(reservation.start_date);
        const currentDate = moment().utc();
        const daysUntilReservation = entryDate.diff(currentDate, 'days');
        if (daysUntilReservation < modificationDeadline) {
            changesAllowed = false;
        }
    }
    return changesAllowed;
}
